"use strict";

/**
 * Provides options to dropdown-like input widget directives that require it.
 *
 * Exposes a controller that can be used to get or set options. To set options from
 * a source other than the reference data or the parent scope, define an attribute
 * directive that has (or gets) the option data, requires rtOptionsProvider, and
 * sets the options on its controller.
 */
module.exports = /* @ngInject */ function() {
  return {
    restrict: "A",
    controller: function() {
      var options = [];

      this.getOptions = function() {
        return options;
      };

      this.setOptions = function(newOptions) {
        options = newOptions;
      };
    }
  };
};



// WEBPACK FOOTER //
// ./app/ui/directives/rtOptionsProvider.js